import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpService } from 'src/app/core/http/http.service';
import { environment } from 'src/environments/environment';
import { DetalleSolicitudModel } from './detalle-solicitud.model';

@Injectable({
  providedIn: 'root'
})
export class GestorSolicitudesConsultas {

  constructor(
    private http: HttpService
  ) { }

  obtenerSolicitudesPorTipoYEstados(
    tipoIdentidad: string,
    numeroIdentidad: string,
    desde: string,
    hasta: string,
    tipoSolicitud: number,
    portal: number,
    estadosArray: number[]
  ): Observable<DetalleSolicitudModel[]> {
    let estados: string = estadosArray.join(',');
    const params = {
      tipoIdentidad,
      numeroIdentidad,
      desde,
      hasta,
      tipoSolicitud,
      portal,
      estados
    };
    return this.http.get<DetalleSolicitudModel[]>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/complementos/filtrar',
      params
    );
  }

   validarSolicitudEnProceso(params: {
    tipoSolicitudId: number;
    tipoIdentidadTitular: string;
    numeroIdentidadTitular: string;
    tipoIdentidadBeneficiario?: string;
    numeroIdentidadBeneficiario?: string;
    desde: string;
    hasta: string;
    portal: number;
    estados: number[];
  }): Observable<boolean> {

    const httpParams = {
      ...params,
      estados: params.estados.join(',')
    };

    return this.http.get<boolean>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/solicitudes/validarSolicitudEnProceso',
      httpParams
    );
  }
}
